import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export const ProtectedAdminRoute: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  // 1. Wait for Auth Check to finish
  if (isLoading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>Loading...</div>;
  }

  // 2. If not authenticated, redirect to login
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // 3. Protocol A: Rider Isolation
  // Riders must NEVER see the Admin Dashboard.
  if (user.role === 'rider') {
    return <Navigate to="/driver/dashboard" replace />;
  }

  // 4. Render the protected page
  return children;
};

export default ProtectedAdminRoute;